import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import styles from './user.module.css';
import {
  postPasswordResetConfirmThunk, EDIT_NEW_PASSWORD, EDIT_RE_NEW_PASSWORD
} from "../../services/actions/password_reset_confirm_form_actions";
import eye from "../../images/eye.svg";
import { NOT_EQUAL_PASSWORDS } from "../../utils/constants";
import { checkInput, getDataFromRoutes, setMetaTags } from "../../utils/util_functions";
import { useSelector, useDispatch } from "react-redux";
import { getConfirmPasswordForm, getLoading } from "../../services/selectors";
import Loader from "../../components/loader/loader";
import { SET_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { ROUTES_CONST } from "../../utils/constants";


const PasswordResetConfirm = () => {

  const { uid, token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST, uid, token);
  const isLoading = useSelector(getLoading);

  const [statusNewPassword, setStatusNewPassword] = useState({});
  const [statusReNewPassword, setStatusReNewPassword] = useState({});
  const [equalPasswords, setEqualPasswords] = useState(true);

  const [formValid, setFormValid] = useState(false);

  const refToNPInput = useRef(null);
  const refToRNPInput = useRef(null);


  const {
    new_password, re_new_password
  } = useSelector(getConfirmPasswordForm);

  const changeNewPassword = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'password');
    setStatusNewPassword({ ...statusNewPassword, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_NEW_PASSWORD, new_password: e.target.value });
  }
  const changeReNewPassword = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'password');
    setStatusReNewPassword({ ...statusReNewPassword, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_RE_NEW_PASSWORD, re_new_password: e.target.value });
  }
  const changeVisibilityNP = () => {
    refToNPInput.current.type === 'password' ?
      refToNPInput.current.type = 'string' :
      refToNPInput.current.type = 'password';
  }
  const changeVisibilityRNP = () => {
    refToRNPInput.current.type === 'password' ?
      refToRNPInput.current.type = 'string' :
      refToRNPInput.current.type = 'password';
  }

  useEffect(() => {
    dispatch({
      type: SET_PATH_PARAMS,
      uid,
      token,
      slug1: '',
      slug2: '',
      slug3: '',
      slug4: ''
    });
    // eslint-disable-next-line
  }, [location]);

  useEffect(() => {
    setEqualPasswords(new_password === re_new_password);
    setFormValid(
      checkInput(new_password, 8, 64, 'password').valid &&
      checkInput(re_new_password, 8, 64, 'password').valid &&
      equalPasswords
    );
    // eslint-disable-next-line
  }, [new_password, re_new_password, equalPasswords]);

  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      postPasswordResetConfirmThunk(
        navigate, uid, token, new_password, re_new_password
      )
    );
  }

  return (
    <main className='main'>
      {isLoading ? <Loader /> : null}
      <h1 className="title title__left">{title}</h1>
      <div className={styles.box}>
        <form onSubmit={handleSubmit} className="form" noValidate>
          <label htmlFor="new_password" className="label_text">
            Новый пароль
            <input
              type="password"
              id="new_password" name="new_password"
              required={true}
              value={new_password}
              onChange={changeNewPassword}
              className="input input__password"
              ref={refToNPInput}
            />
            <img src={eye} className="eye"
              alt='visibility new password' onClick={changeVisibilityNP}
            />
            <p className="error">{statusNewPassword?.text}</p>
          </label>
          <label htmlFor="re_new_password" className="label_text">
            Новый пароль (ещё раз)
            <input
              type="password"
              id="re_new_password" name="re_new_password"
              required={true}
              value={re_new_password}
              onChange={changeReNewPassword}
              className="input input__password"
              ref={refToRNPInput}
            />
            <img src={eye} className="eye"
              alt='visibility re new password' onClick={changeVisibilityRNP}
            />
            <p className="error">
              {statusReNewPassword?.text}
              {!equalPasswords && NOT_EQUAL_PASSWORDS}
            </p>
          </label>
          <button type="submit"
            className={`button ${!formValid ? `button_disabled` : ''}`}
            disabled={!formValid}
          >
            Обновить пароль
          </button>
        </form>
        <div className={styles.aside_block}>
          <p className="text__gray">
            Не забудьте ваш новый пароль
          </p>
        </div>
      </div>
    </main>
  )
}

export default PasswordResetConfirm;
